import ERROR_CONSTANTS from "../Constants/errorConstants";
import { clientLogEvent } from "../Loggers/clientLogEvent";
import { ShowErrorToast } from "../../Views/Common/Toast/toast";

const getIP = async () => {
  const res = await fetch('https://api.ipify.org/?format=json')
  const data = await res.json()
  return data.ip
}
export const safeClientLogEvent = async (data) => {
  const ip = await getIP()
  try {
    await clientLogEvent({ ...data, ip });
  } catch (logErr) {
    ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST)
    return
  }
};
